const HelpIndex = () =>
  import(/* webpackChunkName: "Catalogs" */ 'RootDir/modules/Help/Index.vue');

export default [
  {
    path: '/',
    name: 'help-index',
    component: HelpIndex,
  },
];
